var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3C10.4375 3 10.8438 3.25 11.0625 3.625L17.8125 15.125C18.0312 15.5312 18.0312 16 17.8125 16.375C17.5938 16.7812 17.1875 17 16.75 17H3.25C2.78125 17 2.375 16.7812 2.15625 16.375C1.9375 16 1.9375 15.5312 2.15625 15.125L8.90625 3.625C9.125 3.25 9.53125 3 10 3ZM10 7C9.5625 7 9.25 7.34375 9.25 7.75V11.25C9.25 11.6875 9.5625 12 10 12C10.4062 12 10.75 11.6875 10.75 11.25V7.75C10.75 7.34375 10.4062 7 10 7ZM11 14C11 13.4688 10.5312 13 10 13C9.4375 13 9 13.4688 9 14C9 14.5625 9.4375 15 10 15C10.5312 15 11 14.5625 11 14Z",
    fill: "#A15C07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0d557bb7.svg";
export { ForwardRef as ReactComponent };